import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const GalleryImage = ({ width = 12, height = 12 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      d="M1.91667 11.25H10.0833C10.7277 11.25 11.25 10.7277 11.25 10.0833V1.91667C11.25 1.27233 10.7277 0.75 10.0833 0.75H1.91667C1.27233 0.75 0.75 1.27233 0.75 1.91667V10.0833C0.75 10.7277 1.27233 11.25 1.91667 11.25ZM1.91667 11.25L8.33333 4.83333L11.25 7.75M4.83333 3.95833C4.83333 4.44158 4.44158 4.83333 3.95833 4.83333C3.47508 4.83333 3.08333 4.44158 3.08333 3.95833C3.08333 3.47508 3.47508 3.08333 3.95833 3.08333C4.44158 3.08333 4.83333 3.47508 4.83333 3.95833Z"
      stroke="#52575C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
